import sber from 'assets/img/banking-services/sber.svg'
import tBank from 'assets/img/banking-services/t-bank.svg'
import tochka from 'assets/img/banking-services/tochka.svg'

export const bankingServicesItemData = [
  {
    id: 1,
    title: 'Сбер',
    link: 'https://partners.dasreda.ru/landing/products?partnerID=d314e55e7d232744f2e8',
    imgUrl: sber,
  },
  {
    id: 2,
    title: 'T-банк',
    link: 'https://www.tbank.ru/business/account/?dco_ic=39f249f7-991a-4e88-86a1-4bde4398421b&utm_medium=ptr.act&utm_campaign=sme.partners&partnerId=5-3I1BF2E8B&agentId=5-2FJ2L8VKD&agentSsoId=77b77f80-2a41-4e91-91fa-b5e3ae12f6f0&utm_source=partner_rko_sme',
    imgUrl: tBank,
  },
  {
    id: 3,
    title: 'Точка',
    link: 'https://partner.tochka.com/all-register-free?referer1=WBrega',
    imgUrl: tochka,
  },
]
